import React from 'react';
import { ValueLabel } from '@features/ax/shared/ValueLabel';
import { Badge } from '@shared/ui/badge';

interface CycleDetailsTabProps {
  meterRunDetail?: any;
}

export const CycleDetailsTab: React.FC<CycleDetailsTabProps> = ({
  meterRunDetail
}) => {
  const cycleData = meterRunDetail
  return (
    <div className="space-y-6 pt-2">
      {/* 1. Basic Information Section */}
      <div className="space-y-2.5">
        <h4 className="text-xs font-semibold text-gray-500  tracking-wider pl-0.5">
          Basic Information
        </h4>
        <div className="bg-slate-50/50 border border-slate-200/70 rounded-xl p-6 shadow-sm">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-y-6 gap-x-12">
            <ValueLabel
              label="Cycle Name"
              value={cycleData?.meterSchedule?.meterCycle?.meterCycleName || 'NA'}
            />
            <ValueLabel
              label="Cycle Type"
              value={cycleData?.meterSchedule?.meterCycle?.cycleFrequency || 'NA'}
            />
            <ValueLabel
              label="Utility Services"
              value={cycleData?.meterSchedule?.meterCycle?.productCode?.join(', ') || 'NA'}
            />
          </div>
        </div>
      </div>

      {/* 2. Reading Period Section */}
      <div className="space-y-2.5">
        <h4 className="text-xs font-semibold text-gray-500  tracking-wider pl-0.5">
          Reading Period
        </h4>
        <div className="bg-slate-50/50 border border-slate-200/70 rounded-xl p-6 shadow-sm">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-y-6 gap-x-12">
            <ValueLabel
              label="Period Start"
              value={cycleData?.startDate || 'NA'}
            />
            <ValueLabel
              label="Period End"
              value={cycleData?.endDate || 'NA'}
            />
            <ValueLabel
              label="Data Collection Method"
              value={
                cycleData?.meterSchedule?.meterCycle?.dataCollectionMethod?.label || 'NA'
              }
            />
            <ValueLabel
              label="Read Format"
              value={cycleData?.meterSchedule?.meterCycle?.readFormatDisplay || 'NA'}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
export default CycleDetailsTab;
